<template>
  <v-app>
    <v-app-bar app color="primary" dark >
      <!-- Logo gauche -->
      <v-img alt="MAGIC" src="./assets/logo.png" class="logo-left" />

      <!-- Titre complet -->
      <v-toolbar-title class="title">MAGIC & AIRCORE campaigns</v-toolbar-title>

      <!-- Onglets principaux -->
      <v-tabs v-model="tab" background-color="primary" grow>
        <v-tab value="1">AIRCORE sites</v-tab>
        <v-tab value="2">MAGIC 2023</v-tab>

        <!-- AB2CD avec sous-menu -->
        <v-menu offset-y >
          <template v-slot:activator="{ on, attrs }">
            <v-tab value="3" v-bind="attrs" 
            v-on="on">AB2CD 2025</v-tab>
          </template>
          <v-list>
            <v-list-item @click="showTab(3)">
              <v-list-item-title>AB2CD - Forecasts</v-list-item-title>
            </v-list-item>
            <v-list-item @click="showTab(4)">
              <v-list-item-title>AB2CD - Quicklooks</v-list-item-title>
            </v-list-item>
            <v-divider></v-divider>

    <!-- 🔗 Nouveau sous-menu : ouvre un site externe -->
    <v-list-item @click="openExternalSite">
      <v-list-item-title>AB2CD - Website</v-list-item-title>
    </v-list-item>
          </v-list>
        </v-menu>
      </v-tabs>

      <!-- Logo droite -->
      <v-img alt="Aeris" src="./assets/logoAeris.png" class="logo-right" />
    </v-app-bar>

    <!-- Contenu principal -->
    <v-main>
      <Main v-if="show === 1" />
      <iframe
        v-if="show === 2"
        id="windy"
        src="https://observations.ipsl.fr/aeris/magic/windy/index.html"
        frameborder="0"
        style="width: 100%; height: 100%;"
      ></iframe>
      <iframe
        v-if="show === 3"
        id="windy"
        src="https://observations.ipsl.fr/aeris/magic/windy/indexAB2CD.html"
        frameborder="0"
        style="width: 100%; height: 100%;"
      ></iframe>
      <Quicklooks v-if="show === 4" />
    </v-main>
  </v-app>
</template>

<script>
import Main from './components/Main.vue';
import Quicklooks from './components/Quicklooks.vue';

export default {
  name: 'App',
  components: { Main, Quicklooks },
  data() {
    return {
      show: 1,
      tab: '1'
    };
  },
  mounted() {
    const params = new URLSearchParams(window.location.search)
    if (params.has('ab2cd')) {
      this.tab = 2
    }
  },
  watch: {
    tab(newVal) {
      switch (newVal) {
        case 0:
          this.show = 1
          break
        case 1:
          this.show = 2
          break
        case 2:
          this.show = 3
          break
      }
    }
  },
  methods: {
    openExternalSite() {
      window.open("https://observations.ipsl.fr/aeris/ab2cd/README.html", "_blank"); // 🔗 mets ici ton URL
    },
    showTab(val) {
      if(val<3)
        this.tab = val

      this.show = val
    }
}
};
</script>

<style scoped>
.logo-left {
  width: 136px;
  margin-left: -18px; /* colle le logo complètement à gauche */
}

.logo-right {
  width: 130px;
  margin-right: 10px;
}

.title {
  flex-grow: 0;           /* ne prend que la place nécessaire */
  white-space: nowrap;     
  overflow: visible;      /* montrer tout le texte */
  margin-left: 10px;
  font-size: 18px;        /* ajuste la taille si besoin */
}
</style>
